import { AlertEnum } from '../components/messages/messages.enum';

export class Alert {
    public remove: boolean = true;
    public description: string = "";
    public type: AlertEnum = AlertEnum.Success;
    public alertId: number = 0;
    public icon: string = "";
    public class: string = "";
    public animation: string = "slideInUp";
    public timer: number = 0;

    /**
     * Opcional: texto de acción para alertas con timer (ej. "Continuar sesión").
     * Si existe, el componente puede renderizar un botón de acción.
     */
    public actionLabel?: string;

    /**
     * Opcional: oculta el botón de cerrar (X) para forzar interacción/timeout.
     */
    public hideClose?: boolean;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }

}
